'use client';

import React, { useState, useEffect } from 'react';
import { generateGoogleSearchConsoleMetaTag } from 'libs/track';
import { preload, preconnect, prefetchDNS } from 'react-dom';
import { getS3ObjectUrl } from 'app/libs/url';

const jfOpenHuninnFontCDN = getS3ObjectUrl('/font/jf-openhuninn-2.1.ttf');

const uiconsRegularRoundedFontCDN = getS3ObjectUrl('/font/uicons-regular-rounded.woff2');

export function PreloadResources({
    trackingConfig,
}: {
    trackingConfig: TrackingConfig | null;
}) {
    const [hydrated, setHydrated] = useState(false);

    preload(jfOpenHuninnFontCDN, { as: 'font' });

    preload(uiconsRegularRoundedFontCDN, { as: 'font' });

    preconnect('https://fonts.googleapis.com');

    preconnect('https://fonts.gstatic.com', { crossOrigin: 'anonymous' });

    prefetchDNS('https://fonts.googleapis.com');

    useEffect(() => {
        setHydrated(true);
    }, []);

    if (!hydrated) {
        return null;
    }

    return (
        <head>
            <link
                href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Mulish:ital,wght@0,200..1000;1,200..1000&family=Noto+Sans+TC:wght@100..900&family=Noto+Serif+TC:wght@200..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Raleway:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100..900;1,100..900&display=swap"
                rel="stylesheet"
            />
            <style>{`
                @font-face {
                    font-family: "jf-openhuninn";
                    src:
                        url('${jfOpenHuninnFontCDN}') format('truetype');
                    font-display: swap;
                }
            `}</style>
            <style>{`
                @font-face {
                    font-family: "uicons-regular-rounded";
                        src:
                            url('${uiconsRegularRoundedFontCDN}') format('woff2');
                        font-display: swap;
                }
            `}</style>
            {generateGoogleSearchConsoleMetaTag(
                trackingConfig?.google_search_console_content
            )}
        </head>
    );
}
